import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import * as crypto from 'crypto-js';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { PayByLinkInitiatePayment } from '../../shared/interface/adyen/pay-by-link-initiate-payment.interface';
import { OrderSourceValue } from '../enums/order-source.enum';
import { PayvisionRegistrationResponse } from '../interface/payvision/payvision-registration-reponse.interface';
import { PayvisionRegistration } from '../interface/payvision/payvision-registration.interface';
import { PayvisionSavedCardResponse } from '../interface/payvision/payvision-saved-card-response.interface';

/**
 * @description this service help comunicate with payment service
 * when provider is payvison
 * @date 2018-08-08
 * @export
 * @class PayvisionService
 */
@Injectable()
export class PayvisionService {

    constructor(private _http: Http) { }


    /**
     * @description to get the payvision checkout
     *  registration form
     * @date 2018-07-27
     * @param {number} storeId
     * @param {PayvisionRegistrationRequest} payvisionRegistrationRequest
     * @returns {Observable<any>}
     * @memberof PayvisionService
     */
    getPayvisionForm(storeId: number, payvisionRegistrationRequest: PayvisionRegistration)
        : Observable<PayvisionRegistrationResponse> {
        const headers = this.getPaymentHeaders();
        return this._http
            .post(decodeURIComponent(encodeURIComponent(ApiUrlConstants.paymentApiUrl + 'payments/store/' + storeId +'/payment-checkout-form ')), payvisionRegistrationRequest, { headers: headers })
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }


    getPaymentLogs(webOrderId: String): Observable<any> {
        const headers = this.getPaymentHeaders();
        return this._http
            .get(ApiUrlConstants.paymentApiUrl + 'payments/payment-logs/' + webOrderId , { headers: headers })
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
}
    /**
     * @description to get the Registration status
     * @date 2018-07-31
     * @param {number} storeId
     * @param {string} checkoutOutId
     * @returns {Observable<PayvisionRegistrationResponse>}
     * @memberof PayvisionService
     */
    getPayvisionRegistrationStatus(storeId: number, checkoutOutId: string): Observable<PayvisionRegistrationResponse> {
        const headers = this.getPaymentHeaders();
        return this._http
            .get(ApiUrlConstants.paymentApiUrl + 'payments/store/' + storeId +
                '/checkout-payvision/' + checkoutOutId + '/registration-status', { headers: headers })
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * @description this method will retrive ssaved payvison cards
     * for logged in user
     * @date 2018-08-14
     * @returns {void}
     * @memberof PayvisionService
     */
    getSavedPayvisonCards(memberId: number, isoCountryCode: string, customerPaymentTokenID?: number)
        : Observable<PayvisionSavedCardResponse> {
        memberId = memberId ? memberId : 0;
        const headers = this.getPaymentHeaders();
        let url = ApiUrlConstants.paymentApiUrl + 'members/' + memberId +
        '/cards?countryCode=' + isoCountryCode + '&orderSourceTypeId=' + OrderSourceValue.CUSTOMER;
        url = customerPaymentTokenID ? url + '&customerPaymentTokenID=' + customerPaymentTokenID : url;
        return this._http
            .get(url, { headers: headers })
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     *
     * @param paymentMethod
     * @param paymentInformation
     * @param paymentComponentSettings
     */
    submitPayment(request: any): Observable<any> {
        const headers = this.getPaymentHeaders();
        return this._http
            .post(ApiUrlConstants.paymentApiUrl + 'payments/' + request.webOrderId + '/create-payment-checks',
                JSON.stringify(request), { headers: headers })
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * @description this is used to get
     * payment headers
     * @date 2018-07-26
     * @returns {Headers}
     * @memberof PayvisionService
     */
    getPaymentHeaders(): Headers {
        const headers = new Headers();
        const authHeader = 'PAY ' + environment.paymentApiKey + ':' + this.getHashedValue();
        headers.append('authorization', authHeader);
        return headers;
    }

    initiatePayment(initiateAdyenPayment: PayByLinkInitiatePayment): Observable<any> {
        const headers = this.getPaymentHeaders();
        return this._http.post(ApiUrlConstants.paymentApiUrl + 'payments/initiate-payment', initiateAdyenPayment, { headers: headers })
        .map((res:Response) => res.json())
        .catch(this.handleErrorObservable);
    }
    /**
     * @description this method is used to
     * get payment crypto hashed value
     * @date 2018-07-26
     * @returns {string}
     * @memberof PayvisionService
     */
    getHashedValue(): string {
        const shavalue = crypto.HmacSHA1(environment.paymentSecurityKey, environment.paymentServiceKey);
        return crypto.enc.Base64.stringify(shavalue);
    }
    /**
   * To handle the obervable error response
   * @param  {Response|any} error
   */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error);
    }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/payvision.service.ts